import { DropzoneAreaBase } from 'material-ui-dropzone';
import { Grid, IconButton, withStyles, makeStyles } from '@material-ui/core';
import { colorPalette } from '../../colorPalette';
export const StyledDropzone = withStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        height: '122px',
        backgroundColor: colorPalette.gray100,
        border: `1px dashed ${colorPalette.gray300}`,
        boxSizing: 'border-box',
        borderRadius: '4px',
        minHeight: 'auto',
    },
    active: {
        borderColor: colorPalette.green800,
        background: colorPalette.green100,
    },
    invalid: {
        borderColor: colorPalette.red800,
        background: colorPalette.red100,
    },
    textContainer: {
        color: colorPalette.gray800,
        display: 'flex',
        flexDirection: 'column-reverse',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem',
    },
    text: {
        margin: 0,
        fontSize: '1.4rem',
        lineHeight: '1.8rem',
    },
    icon: {
        color: 'inherit',
        width: '3rem',
        height: '3rem',
        marginBottom: '1rem',
    },
})(DropzoneAreaBase);
export const IconContainer = withStyles({
    root: {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: 6,
        color: colorPalette.white,
    },
})(IconButton);
export const ImageContainer = withStyles({
    root: {
        position: 'relative',
    },
})(Grid);
export const gridItem = {
    height: '130px',
};
export const useStyles = makeStyles({
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '4px',
    },
    description: {
        color: colorPalette.gray700,
        paddingTop: '0.5rem',
    },
    errors: {
        color: colorPalette.red500,
        paddingTop: '0.5rem',
        fontSize: '1.2rem',
        fontWeight: 400,
        lineHeight: 1.66,
    },
    limitFiles: {
        color: colorPalette.gray600,
        fontWeight: 400,
    },
});
